export default {
    methods: {
        formatDate(date, format) {
            if (typeof date == "undefined") {
                return "";
            }
            if (Number.isInteger(date)) {
                let milliseconds = this.$moment(
                    date.toString().length < 12 ?
                    parseInt(date) * 1000 :
                    parseInt(date)
                );
                return this.$moment(Number.parseInt(milliseconds)).format("ll");
            } else {
                let dateFormat = format || "YYYY-MM-DD";
                return this.$moment(date, dateFormat).format("ll");
            }
        },
        formatDateTime(date, format) {
            if (typeof date == "undefined") {
                return "";
            }
            if (Number.isInteger(date)) {
                let milliseconds = this.$moment(
                    date.toString().length < 12 ?
                    parseInt(date) * 1000 :
                    parseInt(date)
                );
                return this.$moment(Number.parseInt(milliseconds)).format(
                    "lll"
                );
            } else {
                let dateFormat = format || "YYYY-MM-DD HH:mm:ss";
                return this.$moment(date, dateFormat).format("lll");
            }
        },
    },
};